import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import {
  Modal,
  DatePicker,
  Input,
  Select,
  Checkbox,
  Button,
  message
} from 'hljd'
import { observer } from 'mobx-react'
import store from './store'
import myStore from '../store'
import { toJS } from 'mobx'

const CheckboxGroup = Checkbox.Group
const Item = Form.Item
const Option = Select.Option
const timeStrOption = [
  { label: '午市', value: ',1,' },
  { label: '晚市', value: ',2,' }
]
@observer
export default class extends Component {
  validation = () => {
    const reg = /^1\d{10}$/
    if (store.params.date === undefined) {
      return '请选择婚期'
    }
    if (store.params.venue === '0') {
      return '请选择婚宴场地'
    }
    if (store.params.meal.length == 0) {
      return '请选择市别'
    }
    if (store.params.userName.trim() === '') {
      return '客户姓名不能为空'
    }
    if (!reg.test(store.params.phone)) {
      return '请输入正确的客户手机号码'
    }
    return 'pass'
  }
  handleOk = () => {
    let msg = this.validation()
    if (msg !== 'pass') {
      return message.warning(msg, 2)
    } else {
      store.save()
    }
  }
  handleCancel = () => {
    store.cancel()
  }
  handleSetDate = value => {
    Object.assign(store.params, {
      date: value
    })
  }
  handleSetVenue = value => {
    Object.assign(store.params, {
      venue: value
    })
  }
  handleSetMeals = checkedValues => {
    Object.assign(store.params, {
      meal: checkedValues
    })
  }
  handleSetUserName = e => {
    Object.assign(store.params, {
      userName: e.target.value
    })
  }
  handleSetPhone = e => {
    Object.assign(store.params, {
      phone: e.target.value
    })
  }
  render() {
    const { modal, loading, params } = store
    const { hotelHalls, MerchantInfo } = myStore
    let allHotelHalls = hotelHalls.map(item => (
      <Option value={item.id} key={item.id}>
        {item.name}
      </Option>
    ))
    return (
      <Modal
        visible={modal.visible}
        title={modal.title}
        onCancel={this.handleCancel}
        style={{ left: 110 }}
        footer={[
          <Button key="back" onClick={this.handleCancel}>
            取消
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={this.handleOk}
          >
            {modal.buttonText}
          </Button>
        ]}
      >
        <Form>
          <Item
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 12 }}
            label="婚期"
            required
          >
            <DatePicker
              onChange={this.handleSetDate}
              value={toJS(params.date)}
              defaultValue={params.date}
            />
          </Item>
          <Item
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 12 }}
            label="婚宴酒店"
            required
          >
            <span>{MerchantInfo.name}</span>
          </Item>
          <Item
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 12 }}
            label="婚宴场地"
            required
          >
            <Select
              onChange={this.handleSetVenue}
              placeholder="请选择"
              value={params.venue.toString()}
            >
              <Option value={'0'}>请选择</Option>
              {allHotelHalls}
            </Select>
          </Item>
          <Item
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 8 }}
            label="市别"
            required
          >
            <CheckboxGroup
              options={timeStrOption}
              onChange={this.handleSetMeals}
              value={toJS(params.meal)}
            />
          </Item>
          <Item
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 12 }}
            label="客户姓名"
            required
          >
            <Input onChange={this.handleSetUserName} value={params.userName} />
          </Item>
          <Item
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 12 }}
            label="客户手机"
            required
          >
            <Input onChange={this.handleSetPhone} value={params.phone} />
          </Item>
        </Form>
      </Modal>
    )
  }
}
